import { useEffect, useState } from "react"
import { fetchGetSubFolders } from "../FolderApi"
import { toast } from "react-toastify"
import Folder from "./Folder"
import { useDispatch, useSelector } from "react-redux"
import { selectTranslations } from "../../../services/i18n/i18nSlice"
import { selectAppInfo } from "../../../services/utils/appInfoSlice"
import { useNavigate } from "react-router-dom";

import question_img from '../../../assets/images/ofa/question.svg'
import { Text } from "../../../components/Text";
import { TitleH3 } from "../../../components/TitleH3";
import { TitleH2 } from "../../../components/TitleH2";
import { Button } from "../../../components/Button";

export default function SubFolders ({parentFolder}) {

    const t = useSelector(selectTranslations)
    const appInfo = useSelector(selectAppInfo)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const hasContent = ( parentFolder?.files?.length > 0 || parentFolder?.video?.length > 0 || parentFolder?.links?.length > 0 ) && parentFolder.parent_folder_id !== null
    const [subFolders, setSubFolders] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [isLoadingMore, setIsLoadingMore] = useState(false)
    const [hasMore, setHasMore] = useState(false)
    const [fetchState, setFetchState] = useState({ start_cursor: null, limit: 20 })

    const loadSubFolders = async (reset = true, cursor = null) => {
        const _params = {
            parent_folder_id: parentFolder?.folder_id,
            limit: fetchState.limit,
            ...(cursor && { start_cursor: cursor })
        }
        const response = await fetchGetSubFolders(_params)
        if (response.success){
            const _new_folders = response.data.folders || []
            setSubFolders(reset ? _new_folders : [...subFolders, ..._new_folders])
            setFetchState({...fetchState, start_cursor: response.data.next_cursor})
            setHasMore(!!response.data.next_cursor && _new_folders.length === fetchState.limit)
            setIsLoading(false)
        } else {
            toast.error(t.training.error_loading_folder)
        }
    }

    const loadMore = async () => {
        if(isLoadingMore) return
        setIsLoadingMore(true)
        await loadSubFolders(false, fetchState.start_cursor)
        setIsLoadingMore(false)
    }

    const subfoldersAreTraining = () => {
        return subFolders.find((f) => ((!f.videos || f.videos?.length === 0) && (!f.links || f.links?.length === 0) && (!f.files || f.files?.length === 0) && f.training?.ready) )
    }

    const openContact = () => {
        navigate('/account', {replace:true, state:{activeModule:'contact'}})
    }

    useEffect(( )=>{
        setIsLoading(true)
        setSubFolders([])
        loadSubFolders()
    },[parentFolder.folder_id])

    return(
        <>
            <div className={`folders_list ${parentFolder?.type === "learning_path" && 'connected'} ${subFolders?.length > 0 ? 'mt-4' : ''} ${hasContent || subfoldersAreTraining() ? 'rounded' : '' }`}>
                {subFolders?.map((folder, folder_id) => {
                    return(
                        <Folder folder={folder} hasContent={hasContent || subfoldersAreTraining()} key={folder_id}/>
                    )
                })}
                {isLoading && Array.from(Array(3), (v,i)=> <Folder key={i}/>)}
            </div>
            {!isLoading && hasMore && subFolders?.length > 0 &&
                <div className="d-flex justify-content-center mt-4">
                    <Button color="secondary" onClick={loadMore} disabled={isLoadingMore}>
                        {t.buttons.load_more}
                    </Button>
                </div>
            }
            {(!isLoading && subFolders?.length === 0 && appInfo?.is_ofa && parentFolder?.parent_folder_id === null) &&
                <div className="d-flex flex-column justify-content-center align-items-center mx-auto mt-5" style={{maxWidth:"400px"}}>
                    <img src={question_img} className="mb-2" style={{width:'48px'}} alt=""/>
                    <TitleH3 className="text-center">{t.ofa.no_ofa}</TitleH3>
                    <Text className="text-center mt-2">{t.ofa.no_ofa_text}</Text>
                    <Button onClick={openContact}>{t.ofa.esse3.contact}</Button>
                </div>
            }
            {subFolders?.length > 0 &&
                <hr style={{background:'#ECECEC', height:'4px', border:'0', borderRadius:'10px'}} />
            }
        </>
    )
}